import BaseTransformer from "./base.transformer"
import ThemeTransformer from "./theme.transformer"
export const baseUri = "/api/landings"

class qrLandingTransformer extends BaseTransformer {
  static fetch(landing) {
    const uuid = this.transformUuid(landing)
    return this.removeEmptyProps({
      uuid,
      iri: this.uuidToIri(baseUri, uuid),
      components: landing.components,
      style: landing.style,
      theme: landing.theme
        ? ThemeTransformer.fetch(
            typeof landing.theme === "string"
              ? { uuid: landing.theme?.split("/").pop() }
              : landing.theme
          )
        : null
    })
  }
}

export default qrLandingTransformer
